// extracted by mini-css-extract-plugin
var _1 = "bqBSa__entry";
var _2 = "bqBSa__entry_lost";
var _3 = "bqBSa__entry_won";
var _4 = "bqBSa__payoutTable";
export { _1 as "entry", _2 as "entry_lost", _3 as "entry_won", _4 as "payoutTable" }
